"use client";

import Button from "@/components/Button/Button";
import "./AICTASection.scss";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";
import { useState } from "react";
import { Container } from "react-bootstrap";

const AICTASection = ({ cta }) => {
  const [showModal, setShowModal] = useState(false);
  const handleClick = () => {
    setShowModal(true);
  };
  if (!cta) return null;

  const { title, description } = cta;

  return (
    <section className="container ai-cta-section" data-aos="zoom-in">
        <div className="blur-bg" />
        <div className="ai-cta-container">
          <h2 className="ai-cta-title">{title}</h2>
          <p className="ai-cta-description">{description}</p>

          <div className="text-center">
            <Button
              variant="primary"
              size="lg"
              className="talk-btn"
              onClick={handleClick}
            >
              Let's Talk
            </Button>
          </div>
        </div>

        <ContactFormModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onConfirm={() => setShowModal(false)}
        />

        <span className="shape shape1" />
        <span className="shape shape2" />
        <span className="shape shape3" />
        <span className="shape shape4" />
    </section>
  );
};

export default AICTASection;
